"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _ThemeProvider = require("../styles/ThemeProvider");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useTheme = function useTheme() {
  return (0, _react.useContext)(_ThemeProvider.ThemeContext);
};

__signature__(useTheme, "useContext{}");

var _default = useTheme;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useTheme, "useTheme", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/useTheme.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/useTheme.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvdXNlVGhlbWUudHMiXSwibmFtZXMiOlsidXNlVGhlbWUiLCJUaGVtZUNvbnRleHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQTs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxRQUFRLEdBQUcsU0FBWEEsUUFBVyxHQUFNO0FBQ3JCLFNBQU8sdUJBQVdDLDJCQUFYLENBQVA7QUFDRCxDQUZEOztjQUFNRCxROztlQUlTQSxROzs7Ozs7Ozs7Ozs7MEJBSlRBLFEiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDb250ZXh0IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBUaGVtZUNvbnRleHQgfSBmcm9tICcuLi9zdHlsZXMvVGhlbWVQcm92aWRlcic7XG5cbmNvbnN0IHVzZVRoZW1lID0gKCkgPT4ge1xuICByZXR1cm4gdXNlQ29udGV4dChUaGVtZUNvbnRleHQpO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgdXNlVGhlbWU7XG4iXX0=